module.exports = __webpack_public_path__ + "static/media/cancel_chat.40269f06.svg";